import Vue from 'vue'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'
import auth from '../auth'
import api from '@api'
import routs from './modules/routs'

Vue.use(VueRouter)
Vue.use(VueAxios, axios)

const router = new VueRouter({
  mode: 'history',
  routes: routs
})

const onSuccess = (response) => {
  return response
}

const onError = (error) => {
  let answer = Promise.reject(error)
  if (error.response && error.response.status === 401) {
    if (error.response.config.url.indexOf('login') === -1) {
      auth.refresh()
        .then((response) => {
          answer = Promise.resolve(error)
        })
        .catch(err => {
          console.log(err)
          api.auth.logoutForExpiredToken()
          answer = Promise.reject(error)
          throw err
        })
    } else {
      return answer
    }
  } else {
    return answer
  }
}

axios.interceptors.response.use(onSuccess, onError)

const config = {
  tokenExpiredUserRegisterRouter: 'tokenExpired.userRegisterRouter',
  tokenNullUserUnregisterRouter: 'tokenNull.userUnregisterRouter',
  tokenReadyUserUnregisterRouter: 'tokenReady.userUnregisterRouter',
  tokenReadyUserRegisterRouter: 'tokenReady.userRegisterRouter'
}

const getTypeAction = (token, isUnRegisteredRoute) => {
  let state = ''

  if (!token) {
    if (!isUnRegisteredRoute) {
      state = config.tokenExpiredUserRegisterRouter
    } else {
      state = config.tokenNullUserUnregisterRouter
    }
  } else {
    if (isUnRegisteredRoute) {
      state = config.tokenReadyUserUnregisterRouter
    } else {
      state = config.tokenReadyUserRegisterRouter
    }
  }

  return state
}

router.beforeEach((to, from, next) => {
  if (to.name === 'available-profiles') {
    next()
    return
  }

  const token = localStorage.getItem('access_token')
  const isUnRegisteredRoute = to.fullPath === '/singin' || to.fullPath === '/singup' || to.fullPath === '/password-reset' || to.name === 'password-update'

  const typeAction = getTypeAction(token, isUnRegisteredRoute)

  const redirect = {
    [config.tokenExpiredUserRegisterRouter]: () => next({ name: 'singin' }),
    [config.tokenNullUserUnregisterRouter]: () => next(),
    [config.tokenReadyUserUnregisterRouter]: () => next({ name: 'home' }),
    [config.tokenReadyUserRegisterRouter]: () => next()
  }

  redirect[typeAction]()

  // if (to.fullPath === '/singin' || to.fullPath === '/singup' || to.fullPath === '/password-reset' || to.name === 'password-update' || to.fullPath === '/units') {
  //   next()
  // } else if (localStorage.getItem('access_token') !== null) {
  //   next()
  // }
})

export default router
